import { apiSlice } from "../../app/api/apiSlice"; // अपनी मुख्य apiSlice को आयात करें

export const aboutUsApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        // 'getAboutUs' नामक एक नया क्वेरी एंडपॉइंट परिभाषित करें
        getAboutUs: builder.query({
            query: () => '/api/v1/about-us', // वह URL जहां से 'about us' डेटा प्राप्त करना है
            // onQueryStarted और queryFulfilled का उपयोग डेटा को लॉग करने या अतिरिक्त साइड इफेक्ट्स के लिए किया जा सकता है
            async onQueryStarted(arg, { queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;
                    console.log('About Us data fetched successfully:', data);
                    // आप यहां डेटा के साथ कुछ और कर सकते हैं, जैसे इसे Redux store में डिस्पैच करना
                } catch (err) {
                    console.error('Failed to fetch About Us data:', err);
                    // त्रुटि को हैंडल करें, जैसे एक त्रुटि संदेश दिखाना
                }
            },
        }),
    }),
});

// हुक को एक्सपोर्ट करें ताकि इसे React कंपोनेंट्स में उपयोग किया जा सके
export const { useGetAboutUsQuery } = aboutUsApiSlice;
